export const environment = {
  production: true,
  apiBaseUrl: 'https://api.nouftaxaday.com',
  // apiBaseUrl: 'http://localhost:8080',
};
